import processClient from '.'
import { getAuthHeaders } from 'utils/requests'
import { cacheClear } from 'utils/memoryCache'

const deleteProcess = async id => {
  const headers = { headers: getAuthHeaders() }
  const response = await processClient.delete(`/delete/${id}`, headers)
  cacheClear('processes:')
  return response
}

export default deleteProcess

